<script>
import Button from "@/components/atoms/button";
import Divider from "@/components/atoms/divider";
import MesDefis from "@/containers/mes-defis";
import FideliteCarteInfo from "@/containers/fidelite-carte-info";
import BandeauGoodNewsCarrefour from "@/components/organisms/bandeau-good-news-carrefour";
import BandeauCarteCarrefourRegistered from "@/components/organisms/bandeau-carte-carrefour-registered";
import PopinAppairage from "@/containers/carrefour-appairage-fid";

import {
  monCompteMaFideliteEmits,
  monCompteMaFideliteProps,
  useMonCompteMaFidelite
} from "./mixin";
import SoldeCarte from "./solde-carte";

export default {
  name: "MaFidelite",
  components: {
    SoldeCarte,
    Button,
    FideliteCarteInfo,
    Divider,
    MesDefis,
    BandeauGoodNewsCarrefour,
    BandeauCarteCarrefourRegistered,
    PopinAppairage
  },
  props: {
    ...monCompteMaFideliteProps()
  },
  emits: [...monCompteMaFideliteEmits()],
  setup(props, context) {
    const { addNewCard, cardSelectedLibelleData, filterFid } =
      useMonCompteMaFidelite(props, context);
    return { addNewCard, cardSelectedLibelleData, filterFid };
  }
};
</script>
<template>
  <div>
    <div class="u-inline-flex">
      <Button
        v-for="carte in filterFid"
        :key="carte.id"
        tab
        size="md"
        :tab-active="cardSelectedLibelleData === carte.attributes.type_carte"
        :to="`/mon-compte/ma-fidelite?type_carte=${carte.attributes.type_carte}`"
        @click="cardSelectedLibelleData = carte.attributes.type_carte"
      >
        <SoldeCarte :carte="carte" />
      </Button>
      <Button
        v-if="filterFid.length === 1 "
        tab
        link
        variant="text-light"
        @click="addNewCard()"
      >
        <span class="u-font-16">
          + Ajouter une carte
        </span>
      </Button>
    </div>
    <div class="c-mafidelite__content">
      <FideliteCarteInfo
        :carte="cardSelected"
        class="u-pt-lg u-px-lg20 u-pb-sm"
      />
      <template v-if="!cardSelected.attributes.expired">
        <div class="u-px-lg20 u-pb-md">
          <BandeauGoodNewsCarrefour
            v-if="!cardSelected.attributes.num_carte_carrefour && cardSelected.attributes.is_data_live"
            @enregistrerCarte="$refs.popinAppairage.show()"
          />
          <BandeauCarteCarrefourRegistered
            v-else-if="!!cardSelected.attributes.num_carte_carrefour"
            :num-carte-carrefour="cardSelected.attributes.num_carte_carrefour"
          />
        </div>
        <Divider />
        <MesDefis
          v-if="!errorDefis"
          :type-carte="cardSelectedLibelleData"
        />
        <p
          v-else
          class="u-color-alert u-font-14 u-p-md"
        >
          Désolé, une erreur s’est produite lors de la récupération de vos défis. Veuillez réessayer plus tard
        </p>
      </template>
    </div>
  </div>
  <PopinAppairage
    ref="popinAppairage"
    :type-carte-selected="cardSelectedLibelleData"
    :cards="fidelite"
    @link="cardSelectedLibelleData = cardSelectedLibelle === 'malin' ? 'cora' : 'malin'"
  />
</template>
<style lang="scss" scoped>
@import "@/assets/styles/components/ma-fidelite";
</style>
